<div class="container">
  <div class="funfacts-inner" style="margin-top: 10px">
    <div *ngIf="data && data.id">
      <div>
        <div *ngIf="data" [innerHTML]="sanitizer.bypassSecurityTrustHtml(data.content)"></div>
      </div>
    </div>
  </div>
</div>
